import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: string, field?: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toString().toLocaleLowerCase();
    return items.filter(it => {
      if (!field) {
        return it.toString().toLowerCase().includes(searchText);
      } else if (it[field] && typeof it[field] != 'number') {
        return it[field].toLowerCase().includes(searchText);
      } else if (it[field] && typeof it[field] == 'number') {
        it[field] = it[field].toString();
        return it[field].includes(searchText);
      }

    });
  }

}
